import { isMobileOnly, isTablet } from 'mobile-device-detect'

export default {
  data () {
    return {
      windowWidth: 1140
    }
  },
  beforeMount () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.windowWidth = window.innerWidth
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    isMobile () {
      if (this.windowWidth < 601 || isMobileOnly) {
        return true
      }
      return false
    },
    isTablet () {
      if ((this.windowWidth < 1140) || isTablet) {
        return true
      }
      return false
    }
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
    }
  }
}
